import React from 'react';

export default function Shimmer() {
  return (
    <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-5 w-full">
      {Array.from({ length: 12 }).map((_, index) => (
        <div key={index} className="space-y-4 rounded-2xl glass-card p-3 animate-pulse">
          <div className="aspect-video w-full rounded-xl bg-slate-800/80"></div>
          <div className="flex gap-3 items-start">
            <div className="h-9 w-9 rounded-full bg-slate-800/80 shrink-0"></div>
            <div className="space-y-2 flex-1">
              <div className="h-3 w-4/5 rounded bg-slate-800/80"></div>
              <div className="h-2.5 w-1/2 rounded bg-slate-800/60"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
